import React from 'react';

const styles = {
  card: {
    background: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: 8,
    padding: '16px 20px',
    minWidth: 140,
  },
  label: {
    fontFamily: 'var(--font-heading)',
    fontSize: 10,
    fontWeight: 500,
    color: 'var(--color-text-dim)',
    textTransform: 'uppercase',
    letterSpacing: 1.5,
    marginBottom: 6,
  },
  value: {
    fontFamily: 'var(--font-data)',
    fontSize: 22,
    fontWeight: 500,
    color: 'var(--color-text)',
  },
  unit: {
    fontSize: 12,
    color: 'var(--color-text-dim)',
    marginLeft: 4,
  },
  details: {
    fontFamily: 'var(--font-body)',
    fontSize: 11,
    color: 'var(--color-text-dim)',
    marginTop: 6,
    lineHeight: 1.5,
  },
};

export default function StatCard({ label, value, unit, color, details, icon }) {
  return (
    <div style={styles.card}>
      <div style={styles.label}>{label}</div>
      <div style={{ ...styles.value, color: color || 'var(--color-text)', display: 'flex', alignItems: 'center', gap: 8 }}>
        {icon}
        <span>{value}</span>
        {unit && <span style={styles.unit}>{unit}</span>}
      </div>
      {details && (
        <div style={styles.details}>
          {details.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>
      )}
    </div>
  );
}
